import React from 'react';
import { DatePicker } from 'antd';
import {
    RANGE_TIME_INCLUED_TODAY,
    RANGE_TIME_UNINCLUED_TODAY,
    RANGE_TIME_UNINCLUED_TODAY_MONTH,
    RANGE_TIME_INCLUED_TODAY_MONTH,
    RANGE_TIME_INCLUED_TODAY_CURRENT_MONTH,
    RANGE_TIME_UNINCLUED_TODAY_CURRENT_MONTH
} from 'utils/const';
import {disabledDateAfterNow} from 'utils/tool';
const { RangePicker } = DatePicker;
class BaseRangePicker extends React.Component {

    constructor(props){
        super(props);
        let _defaultValue = RANGE_TIME_UNINCLUED_TODAY;
        this._default7 = RANGE_TIME_UNINCLUED_TODAY;
        this._default30 = RANGE_TIME_UNINCLUED_TODAY_MONTH;
        this._defaultMonth = RANGE_TIME_UNINCLUED_TODAY_CURRENT_MONTH;
        if(props.incluedToday){
            _defaultValue = RANGE_TIME_INCLUED_TODAY;
            this._default7 = RANGE_TIME_INCLUED_TODAY;
            this._default30 = RANGE_TIME_INCLUED_TODAY_MONTH;
            this._defaultMonth = RANGE_TIME_INCLUED_TODAY_CURRENT_MONTH;
        }

        this.state = {
            selectTime : this.props.defaultValue?this.props.defaultValue:_defaultValue
        };
    }

    changeSelectTime(times){
        this.setState({selectTime:times});
    }

    timeChange = (e)=>{
        if(e.length === 0) {
            return;
        }
        this.props.onChange && this.props.onChange(e);
        this.setState({selectTime:e});
    }

    getSelectTime(){
        return this.state.selectTime;
    }
    render(){
        let _disabledDate = (current) => disabledDateAfterNow(current);
        if(this.props.incluedToday){
            _disabledDate = (current) => disabledDateAfterNow(current,true);
        }
        return (
            <RangePicker
                ranges={{'7 days': this._default7, '30 days': this._default30,'Current month':this._defaultMonth }}
                style={{width:280}}
                allowClear={false}
                onChange={this.timeChange}
                value={this.state.selectTime}
                disabledDate={_disabledDate}/>
        );
    }
}
export default BaseRangePicker;



// WEBPACK FOOTER //
// ./src/components/BaseRangePicker/index.js